import { useCallback, useEffect, useState } from 'react';

import { ThemeContext } from '../context/ThemeContext';

export const ThemeContextProvider = ({ children }) => {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    // Check saved theme or default to light
    const savedTheme = localStorage.getItem('theme') || 'light';
    setTheme(savedTheme);
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  const toggleTheme = () => {
    const nextTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(nextTheme);
    document.documentElement.setAttribute('data-theme', nextTheme);
    localStorage.setItem('theme', nextTheme);
  };

  const getThemeVariable = useCallback(
    (varName) => {
      const selector = `[data-theme='${theme}']`;

      const element = document.querySelector(selector);
      if (!element) return null;

      const style = getComputedStyle(element);
      return style.getPropertyValue(`--${varName}`).trim();
    },
    [theme]
  );

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, getThemeVariable }}>
      {children}
    </ThemeContext.Provider>
  );
};
